import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  HireDotNetProcessInitial,
  HireDotNetProcessSelection,
  HireDotNetProcessInterview,
  HireDotNetProcessOnboarding,
} from "../../../app-constants";

function Hiredotnetprocess() {
  return (
    <section
      className="hire_dot_net_process p-100"
      style={{ background: "#F8F8FB" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={9}
            xxl={9}
            className="m-auto text-center"
          >
            <h2>
              Hire Dot Net Core Developers in 2 Days through Our Smooth Process
            </h2>
            <p>
              We believe in facilitating our clients with instant solutions
              right according to their requirements and that’s why we keep our
              hiring process for .Net developers quite simple. Following 4 easy
              steps, you can hire .Net developers of your choice:
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="hire_dot_process_box">
                  <div className="hire_dot_process-img">
                    {HireDotNetProcessInitial}
                  </div>
                  <div className="hire_dot_process_content">
                    <h5>Initial Consultation</h5>
                    <p>
                      Consult with our professionals and get the best
                      recommendation on our products for your project .NET
                      developers.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="hire_dot_process_box">
                  <div className="hire_dot_process-img">
                    {HireDotNetProcessSelection}
                  </div>
                  <div className="hire_dot_process_content">
                    <h5>Candidate Selection</h5>
                    <p>
                      Choose from a list of the most presented and high-quality
                      .NET developers that will suit your specific needs.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="hire_dot_process_box">
                  <div className="hire_dot_process-img">
                    {HireDotNetProcessInterview}
                  </div>
                  <div className="hire_dot_process_content">
                    <h5>Interview & Assessment</h5>
                    <p>
                      Ask for interviews and technical evaluations to guarantee
                      the right talent for the job for your project.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="hire_dot_process_box">
                  <div className="hire_dot_process-img">
                    {HireDotNetProcessOnboarding}
                  </div>
                  <div className="hire_dot_process_content">
                    <h5>Onboarding and Integration</h5>
                    <p>
                      Get the best and most qualified developers from the list
                      and smoothly include them in your project squad.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Hiredotnetprocess;
